import { useMutation } from "@tanstack/react-query";
import { postMobilityInstallDownload } from "../api/mobility";

const usePostMobilityInstallDownload = () => {
  const mutation = useMutation({
    mutationFn: postMobilityInstallDownload,
  });
  return mutation;
};

export default usePostMobilityInstallDownload;
